



















































































































import { Component, Vue } from "vue-property-decorator";
import ContentAdd from "./modals/contentAdd.vue";
import ContentUpdate from "./modals/contentUpdate.vue";
import Ajax from '../../lib/ajax';
import Content from "@/store/entities/content";

@Component({
  components: { ContentAdd, ContentUpdate },
})

export default class ContentManagement extends Vue {
  search: string = "";
  mockData:any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  isOpenModal: boolean = false;
  isOpenUpdateModal: boolean = false;
  contents: Content[] = [];
  selectedItem:Content=new Content();


  
  async created() {
    (this.headers = [

      { text: "Başlık", value: "title" },
      { text: "İçerik", value: "content" },
      { text: "Resim", value: "image" },
      { text: "Sıra No", value: "image" },
      { text: "İşlemler", value: "transactions" },

    ]),

    await this.getContents();
      

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "İçerik Yönetimi", disabled: true },
    ];

    
  }
  confirmDelete(item) {
    this.$swal({
      title: "Kayıt Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then(async (result) => {
      if (result.isConfirmed) {
        
       await  Ajax.delete(
        '/api/services/app/Admin/DeleteContent?input=' + item.id
      );

        Vue.$toast.success("Silme Başarılı");

        this.getContents();
      }
    
    });
  }



  data() {
    return {
      page: 1,
      pageCount: 0,
    
    };
  }

  truncateText(text) {
      if(text!=null){
        if (text.length > 100) {
        return text.slice(0, 100) + '...';
      }
      }
      
      return text;
    }
  

  cancelModal() {
    this.isOpenModal = false;
    this.isOpenUpdateModal = false;

  }
  async getContents(){
    var response = await Ajax.get(
        '/api/services/app/Admin/GetContents'
      );
      var data = response.data.result.items;
      this.contents=data;
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getContents();
  }

  openUpdateModal(item) {
    this.selectedItem=item;
    this.isOpenUpdateModal = true;

  }
  closeUpdateModal() {
    this.isOpenUpdateModal = false;
     this.getContents();
  }


}
